import { render, staticRenderFns } from "./BaseHeaderHelp.vue?vue&type=template&id=312f6e54&scoped=true&"
import script from "./BaseHeaderHelp.vue?vue&type=script&lang=js&"
export * from "./BaseHeaderHelp.vue?vue&type=script&lang=js&"
import style0 from "./BaseHeaderHelp.vue?vue&type=style&index=0&id=312f6e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312f6e54",
  null
  
)

export default component.exports